module.exports = __webpack_public_path__ + "static/img/cover1.848375e.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/cover1.png
// module id = MVR5
// module chunks = 1